import React, { useEffect, useRef, useState, useCallback } from "react";
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import api from "../../../service";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Container,
  CardsWrapper,
  Card,
  PanelWrapper,
  PanelContent,
  IconWrapper,
  CardTitle,
  TitlePanel,
  SubTitlePanel,
  TextDetailsPanel,
  CardDescription,
  StatsContainer,
  StatItem,
  StatNumber,
  StatLabel,
  ListWrapperLeft,
  ListWrapperRight,
  ListInfo,
  CredentialsStatus,
  ContractInfoWrapper,
  ContractNumber,
  ContractName,
  ScrollContainer,
  StyledCollapse,
  StyledPanel,
  DropDetails,
  PriceDetailsPanel,
  ContainerTop,
  IconContainer,
  EndServiceItens,
  ProductContainer,
  SubTitleHistory,
  Key,
  LinkButton,
} from "./styles";
import {
  SearchContainerFormItem,
  InputWrapper,
  IconWrapperSearchFormItem,
  StyledInput,
} from "../Services/style";
import { useHistory } from "react-router-dom";
import { Form, notification } from "antd";
import ServiceTimer from "../../../components/ServiceTimer";
import EndServiceButton from "../../../components/EndServiceButton";
import {
  ArrowLeft,
  ContractIcon,
  CredentialsIcon,
  DotIcon,
  SalesIcon,
  TransfersIcon,
} from "./card-icons";
import { ContractNumberBadge } from "../components/badges";
import { SkeletonDiv } from "../Services/Sales/components/ProductInfo/styles";
import { Empty } from "../Services/Sales/components/Empty";
import { Flex } from "../Services/Sales/PurchaseSummary/style";
import { ChevronDown2 } from "../components/Icons/chevron-down";
import PurchaseReceipt from "../Services/Sales/components/PurchaseReceipt";
import { useReactToPrint } from "react-to-print";
import cnpjCpfFormatter from "../../../utils/cnpjCpfFormatter";
import { toNumber } from "../../../utils/toNumber";
import { SchedulingCard } from "./SchedulingCard";

const StaffServicePanel = () => {
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const history = useHistory();
  const opportunityId = localStorage.getItem("serviceOpportunityId");
  const fantasyname = localStorage.getItem("serviceFantasyname");
  const contractNumber = localStorage.getItem("serviceContractNumber");
  const systemUserId = localStorage.getItem("serviceSystemUserId");
  const [products, setProducts] = useState([]);
  const [credentialStats, setCredentialStats] = useState([]);
  const [credentialsHistory, setCredentialsHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCredentials, setLoadingCredentials] = useState(false);
  const [errorloadingCredentials, setErrorLoadingCredentials] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [errorloadingProducts, setErrorLoadingProducts] = useState(false);

  const [stopMonitorRoute, setStopMonitorRoute] = useState(false);
  const [formFilterProducts] = Form.useForm();
  const [formFilterCredentials] = Form.useForm();
  const [filterProducts, setFilterProducts] = useState([]);
  const [filterCredentials, setFilterCredentials] = useState([]);
  const [hasSearchedCredentials, setHasSearchedCredentials] = useState(false);
  const [hasSearchedProducts, setHasSearchedProducts] = useState(false);
  const [credentialScheduleStatus, setCredentialScheduleStatus] =
    useState(null);

  // O pedido de impressão é feito somente sob demanda
  const [printOrderId, setPrintOrderId] = useState(null);
  const [printData, setPrintData] = useState(null);

  const contentRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef,
    preserveAfterPrint: false,
    suppressErrors: true,
    onAfterPrint: () => {
      setPrintOrderId(null);
      setPrintData(null);
    },
  });

  // Acionar impressão após a montagem do conteúdo imprimível com dados recuperados
  useEffect(() => {
    if (printOrderId && printData) {
      const timeoutId = setTimeout(() => {
        handlePrint();
      }, 0);
      return () => clearTimeout(timeoutId);
    }
  }, [printOrderId, printData, handlePrint]);

  const mapInvoiceToReceiptData = (order) => {
    const taxes = [
      { label: "COFINS", value: toNumber(order.cofins) },
      { label: "CSLL", value: toNumber(order.csll) },
      { label: "IR", value: toNumber(order.incomeTax) },
      { label: "PIS", value: toNumber(order.pis) },
    ];

    const productsList = order.items.map((item) => {
      const {
        productName = "-",
        quantity = 0,
        unitPrice = 0,
        totalPrice = 0,
      } = item;

      return {
        title: productName,
        qty: toNumber(quantity) || 0,
        value: toNumber(unitPrice) || 0,
        totalPrice: toNumber(totalPrice) || 0,
        currency: intl?.locale?.startsWith("pt") ? "BRL" : "USD",
      };
    });

    return {
      cnpj: cnpjCpfFormatter(order.companyDocument, "J"),
      subtotal: toNumber(order.subtotal),
      taxClassification: order.taxClassification,
      checkoutInfo: {
        orderNumber: order.orderNumber,
        discounts: toNumber(order.discounts),
        totalValue: toNumber(order.total),
        taxes,
      },
      purchaseInfo: {
        name: order.buyerName,
        document: order.buyerDocument,
        phone: order.buyerPhone,
        seller: order.sellerName,
        paymentMethod: order.paymentMethod,
        cardReader: order.cardReader,
        purchaseDate: order.purchaseDate,
      },
      cartProducts: productsList,
      currency: intl.locale === "pt" ? "BRL" : "USD",
    };
  };

  const handlePrintOrder = async (orderId) => {
    try {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await api.get(
        `/ecommerce/getorder/?orderNumber=${orderId}&userId=${systemUserId}`,
        headers
      );
      const order = response.data?.receipt;

      if (!order) throw new Error("missing_invoice_output");

      const data = mapInvoiceToReceiptData(order);
      setPrintData(data);
      setPrintOrderId(orderId);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + (error.response?.data?.code || "unknown"),
        }),
      });
    }
  };

  function handleFilterProducts() {
    setLoadingProducts(true);
    setHasSearchedProducts(true);

    const searchTerm = formFilterProducts.getFieldValue("searchNameProducts");

    const filteredProducts = products.filter((product) => {
      if (!searchTerm) return true;

      return product.productName
        .toLowerCase()
        .trim()
        .includes(searchTerm.toLowerCase().trim());
    });

    setFilterProducts(filteredProducts);
    setLoadingProducts(false);
  }

  function handleFilterCredentials() {
    setLoadingCredentials(true);
    setHasSearchedCredentials(true);
    const searchTerm = formFilterCredentials.getFieldValue("searchCredentials");
    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    const filteredCredentials = credentialsHistory.filter((credential) => {
      if (!searchTerm) return true;

      return credential.collaboratorName == null
        ? `${intl.formatMessage({ id: "credential_" })} ${intl.formatMessage({
            id: credential.type,
          })}`
            .toLowerCase()
            .trim()
            .includes(normalizedSearchTerm)
        : credential.collaboratorName
            .toLowerCase()
            .trim()
            .includes(normalizedSearchTerm) ||
            intl
              .formatMessage({ id: credential.type })
              .toLowerCase()
              .trim()
              .includes(normalizedSearchTerm);
    });

    setFilterCredentials(filteredCredentials);
    setLoadingCredentials(false);
  }

  useEffect(() => {
    if (!stopMonitorRoute) {
      const handleKeyPress = (event) => {
        const pressedKey = event.key.toLowerCase();

        const routes = {
          q: "/staff-access/services/sales",
          r: "/staff-access/services/credentials",
          t: "/staff-access/services/transfer-history",
          p: "/staff-access/services/contract",
        };

        if (routes[pressedKey]) {
          history.push(routes[pressedKey]);
        }
      };

      window.addEventListener("keydown", handleKeyPress);
      return () => {
        window.removeEventListener("keydown", handleKeyPress);
      };
    }
  }, [history, stopMonitorRoute]);

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === "POP") {
        window.history.pushState(null, "", window.location.href);
        return false;
      }
    });

    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      unblock();
      window.removeEventListener("popstate", handlePopState);
    };
  }, [history]);

  useEffect(() => {
    startService();
    fetchProducts();
    fetchCredentialsHistory();
    patchOpportunityNumber();
  }, []);

  const startService = async () => {
    const serviceId = localStorage.getItem("serviceId");

    if (!serviceId) {
      setLoading(true);
      try {
        const response = await api.post(
          `/staff/attendance/start?contract=${contractNumber}&userId=${systemUserId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        localStorage.setItem("serviceId", response.data.id);
      } catch (error) {
        notification.error({
          message: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + error.response?.data?.code,
          }),
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchProducts = async () => {
    setLoadingProducts(true);
    try {
      const response = await api.get(
        `/ecommerce/products?contractNumber=${contractNumber}&type=confirmed&userId=${systemUserId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const confirmedProducts = response.data.productAcquiredDetailsDTO || [];

      setProducts(confirmedProducts);
      setFilterProducts(confirmedProducts);
    } catch (error) {
      setErrorLoadingProducts(true);
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "productsError",
        }),
      });
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchCredentialsHistory = async () => {
    setLoadingCredentials(true);
    try {
      const response = await api.get(
        `/accreditation/history?opportunityId=${opportunityId}&userId=${systemUserId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCredentialStats(response.data.credentialSumQuotaOutput);
      setCredentialsHistory(response.data.credentialHistoryOutputs);
      setFilterCredentials(response.data.credentialHistoryOutputs);
      setCredentialScheduleStatus(
        response.data.credentialScheduleStatusOutput ?? null
      );
    } catch (error) {
      setErrorLoadingCredentials(true);
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "credentialsError",
        }),
      });
    } finally {
      setLoadingCredentials(false);
    }
  };

  const patchOpportunityNumber = async () => {
    try {
      const response = await api.patch(
        `/admin/opportunity?page=0&per_page=10`,
        {
          accountName: "",
          boothNumber: "",
          contractNumber: contractNumber,
          eventEditionName: "",
          type: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const opportunityId =
        response.data.opportunityInformation[0].opportunityId;

      localStorage.setItem("serviceOpportunityNumber", opportunityId);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "api.error." + error.response?.data?.description || "unknown",
        }),
      });
    }
  };

  const cards = [
    {
      title: intl.formatMessage({ id: "sales" }),
      CardDescription: intl.formatMessage({
        id: "sell_​​event_credentials_and_items",
      }),
      icon: <SalesIcon />,
      color: "#155DFC",
      keyboardKey: "Q",
      route: "/staff-access/services/sales",
      shadowColor: "#155dfc3d",
    },
    {
      title: intl.formatMessage({ id: "credentials" }),
      CardDescription: intl.formatMessage({
        id: "register_associate_dissociate_and_print_credentials",
      }),
      icon: <CredentialsIcon />,
      color: "#FE9A00",
      keyboardKey: "R",
      route: "/staff-access/services/credentials",
      shadowColor: "#FE9A003D",
    },
    {
      title: intl.formatMessage({
        id: "transfer_history",
      }),
      CardDescription: intl.formatMessage({
        id: "view_credential_transfers",
      }),
      icon: <TransfersIcon />,
      color: "#8E51FF",
      keyboardKey: "T",
      route: "/staff-access/services/transfer-history",
    },
    {
      title: intl.formatMessage({
        id: "contract",
      }),
      CardDescription: intl.formatMessage({
        id: "view_contract_information",
      }),
      icon: <ContractIcon />,
      color: "#00C951",
      keyboardKey: "P",
      route: "/staff-access/services/contract",
      shadowColor: "#00C9513D",
    },
  ];

  const stats = [
    {
      number: credentialStats.total || 0,
      label: intl.formatMessage({
        id: "total",
      }),
    },
    {
      number: credentialStats.withdrawal || 0,
      route: "/staff-access/services/credentials",
      tabKey: "4",
      label: intl.formatMessage({ id: "withdrawals" }),
    },
    {
      number: credentialStats.printed || 0,
      route: "/staff-access/services/credentials",
      tabKey: "3",
      label: intl.formatMessage({ id: "printed_plural" }),
    },
    {
      number: credentialStats.associated || 0,
      route: "/staff-access/services/credentials",
      tabKey: "2",
      label: intl.formatMessage({ id: "associated2" }),
    },
    {
      number: credentialStats.transferred || 0,
      label: intl.formatMessage({ id: "transferred_plural" }),
    },
    {
      number: credentialStats.available || 0,
      route: "/staff-access/services/credentials",
      tabKey: "1",
      label: intl.formatMessage({ id: "available" }),
    },
  ];

  const handleStatClick = useCallback(
    ({ route, tabKey }) => {
      history.push({ pathname: route, state: { tabKey } });
    },
    [history]
  );

  return (
    <Container>
      {/* hidden printable content, mounted only when user clicks an order number */}
      {printOrderId && printData && (
        <div style={{ display: "none" }}>
          <div ref={contentRef}>
            <PurchaseReceipt data={printData} />
          </div>
        </div>
      )}
      <ContractInfoWrapper>
        <div>
          <ContractNumberBadge contractNumber={contractNumber} />
          <ContractName>{fantasyname.toLowerCase()}</ContractName>{" "}
        </div>

        <EndServiceItens>
          <ServiceTimer />
          <EndServiceButton />
        </EndServiceItens>
      </ContractInfoWrapper>

      <CardsWrapper>
        {cards.map((card, index) => (
          <Card
            onClick={() => history.push(card.route)}
            key={index}
            id={`card-${index}`}
          >
            <IconContainer>
              <IconWrapper
                background={card.color}
                shadowColor={card.shadowColor}
              >
                {card.icon}
              </IconWrapper>
              <Key>{card.keyboardKey}</Key>
            </IconContainer>

            <div>
              <CardTitle>
                {card.title}
                <ArrowLeft />
              </CardTitle>
              <CardDescription>{card.CardDescription}</CardDescription>
            </div>
          </Card>
        ))}
      </CardsWrapper>

      <PanelWrapper>
        <PanelContent>
          <div className="content">
            <TitlePanel>{intl.formatMessage({ id: "credentials" })}</TitlePanel>
            <StatsContainer>
              {stats.map((stat, index) => (
                <StatItem
                  key={index}
                  onClick={stat.route ? () => handleStatClick(stat) : undefined}
                  style={{ cursor: stat.route ? "pointer" : "default" }}
                >
                  <StatNumber>{stat.number}</StatNumber>
                  <StatLabel>{stat.label}</StatLabel>
                </StatItem>
              ))}
            </StatsContainer>
            <SchedulingCard
              scheduleStatus={credentialScheduleStatus}
              loading={loadingCredentials}
            />
            <SubTitleHistory>
              {intl.formatMessage({
                id: "history",
              })}
            </SubTitleHistory>
          </div>

          <SearchContainerFormItem
            style={{ marginBottom: "-3px", marginTop: "-5px" }}
          >
            <InputWrapper>
              <Form form={formFilterCredentials}>
                <div>
                  <IconWrapperSearchFormItem>
                    <SearchOutlined />
                  </IconWrapperSearchFormItem>

                  <Form.Item name="searchCredentials">
                    <StyledInput
                      value=""
                      style={{ paddingLeft: "36px" }}
                      placeholder={intl.formatMessage({
                        id: "SEARCH_NAME_AND_TYPE",
                      })}
                      onChange={handleFilterCredentials}
                      onFocus={() => {
                        setStopMonitorRoute(true);
                      }}
                      onBlur={() => {
                        setStopMonitorRoute(false);
                      }}
                    />
                  </Form.Item>
                </div>
              </Form>
            </InputWrapper>
          </SearchContainerFormItem>

          <ScrollContainer>
            {!loadingCredentials &&
              !errorloadingCredentials &&
              filterCredentials.map((credencial, index) => (
                <ListWrapperLeft
                  key={index}
                  style={{
                    animation: "fadeIn 0.5s ease-in-out",
                    opacity: 1,
                  }}
                >
                  <ListInfo>
                    <TextDetailsPanel type="title">
                      {credencial.collaboratorName
                        ? credencial.collaboratorName
                        : `${intl.formatMessage({
                            id: "credential_",
                          })} ${intl.formatMessage({ id: credencial.type })}`}
                    </TextDetailsPanel>
                    {credencial.collaboratorName && (
                      <TextDetailsPanel>
                        {intl.formatMessage({
                          id: "type",
                        })}
                        {": "}
                        {intl.formatMessage({
                          id: credencial.type,
                        })}
                      </TextDetailsPanel>
                    )}
                    <TextDetailsPanel>
                      <FormattedMessage id="caex_acquired_through" />
                      <FormattedMessage id={credencial.origin} />
                    </TextDetailsPanel>
                  </ListInfo>

                  <CredentialsStatus status={credencial.status}>
                    <DotIcon />
                    {intl.formatMessage({
                      id: credencial.status.toLowerCase(),
                    })}
                  </CredentialsStatus>
                </ListWrapperLeft>
              ))}

            {hasSearchedCredentials &&
              !loadingCredentials &&
              !errorloadingCredentials &&
              filterCredentials.length === 0 && (
                <Empty intlId="NO_RESULTS_FOR_FILTER" />
              )}

            {!loadingCredentials && errorloadingCredentials && (
              <Empty intlId="credentialsError" />
            )}

            {loadingCredentials &&
              Array.from({ length: 15 }).map((_, i) => (
                <CredentialSkeleton key={i} />
              ))}
          </ScrollContainer>
        </PanelContent>

        <PanelContent right>
          <TitlePanel>
            {intl.formatMessage({
              id: "purchased_products",
            })}
          </TitlePanel>

          <SearchContainerFormItem
            style={{ marginBottom: "-13px", marginTop: "-10px" }}
          >
            <InputWrapper>
              <Form form={formFilterProducts}>
                <div>
                  <IconWrapperSearchFormItem>
                    <SearchOutlined />
                  </IconWrapperSearchFormItem>

                  <Form.Item name="searchNameProducts">
                    <StyledInput
                      value=""
                      style={{ paddingLeft: "30px" }}
                      placeholder={intl.formatMessage({
                        id: "SEARCH_ONLY_NAME",
                      })}
                      onChange={handleFilterProducts}
                      onFocus={() => {
                        setStopMonitorRoute(true);
                      }}
                      onBlur={() => {
                        setStopMonitorRoute(false);
                      }}
                    />
                  </Form.Item>
                </div>
              </Form>
            </InputWrapper>
          </SearchContainerFormItem>

          <ScrollContainer error={errorloadingProducts}>
            <ListWrapperRight>
              {!loadingProducts &&
                filterProducts.map((item) => (
                  <StyledCollapse
                    key={item.key}
                    accordion
                    expandIcon={({ isActive }) => (
                      <RightOutlined
                        style={{
                          marginTop: "-10px",
                          color: "rgba(98, 116, 142, 1)",
                          transition: "transform 0.2s",
                          transform: `rotate(${isActive ? 270 : 90}deg)`,
                        }}
                      />
                    )}
                    expandIconPosition="end"
                  >
                    <StyledPanel
                      header={
                        <ContainerTop>
                          <ProductContainer>
                            <SubTitlePanel>
                              {item?.productName || "N/A"}
                            </SubTitlePanel>
                            <TextDetailsPanel>
                              {intl.formatMessage({
                                id: "type",
                              })}
                              {": "}
                              {intl.formatMessage({
                                id: item.type,
                              })}
                            </TextDetailsPanel>
                          </ProductContainer>

                          <PriceDetailsPanel>
                            {new Intl.NumberFormat(intl.locale, {
                              style: "currency",
                              currency: intl.locale === "en" ? "USD" : "BRL",
                            }).format(item.unitPrice)}
                          </PriceDetailsPanel>
                        </ContainerTop>
                      }
                      key={item.key}
                    >
                      <DropDetails>
                        <TextDetailsPanel>
                          {intl.formatMessage({
                            id: "quantity",
                          })}
                          : {item.quantity || "N/A"}
                        </TextDetailsPanel>
                        <TextDetailsPanel>
                          {intl.formatMessage({
                            id: "order_n",
                          })}{" "}
                          {item.orderId ? (
                            <LinkButton
                              onClick={() => handlePrintOrder(item.orderId)}
                            >
                              {item.orderId}
                            </LinkButton>
                          ) : (
                            "N/A"
                          )}
                        </TextDetailsPanel>
                        <TextDetailsPanel>
                          {intl.formatMessage(
                            { id: "paid_on" },
                            { value: item.paymentDate || " N/A" }
                          )}
                        </TextDetailsPanel>
                        <TextDetailsPanel>
                          {intl.formatMessage({
                            id: "sale_data",
                          })}{" "}
                          {item.saleDate || " N/A"}
                        </TextDetailsPanel>
                      </DropDetails>
                    </StyledPanel>
                  </StyledCollapse>
                ))}

              {hasSearchedProducts &&
                !loadingProducts &&
                !errorloadingProducts &&
                filterProducts.length === 0 && (
                  <Empty intlId="NO_RESULTS_FOR_FILTER" />
                )}

              {!loadingProducts && errorloadingProducts && (
                <Empty intlId="productsError" />
              )}

              {loadingProducts &&
                Array.from({ length: 35 }).map((_, i) => (
                  <AdquiredProductsSkeleton key={i} />
                ))}
            </ListWrapperRight>
          </ScrollContainer>
        </PanelContent>
      </PanelWrapper>
    </Container>
  );
};

export default StaffServicePanel;

function CredentialSkeleton() {
  const randomValue = () =>
    `${Math.floor(Math.random() * (200 - 50 + 1)) + 50}px`;
  return (
    <ListWrapperLeft>
      <ListInfo>
        <SkeletonDiv width={randomValue()} height="14px" />
        <SkeletonDiv width={randomValue()} height="14px" />
        <SkeletonDiv width={"140px"} height="14px" />
      </ListInfo>

      <CredentialsStatus status={""}>
        <DotIcon />
        <SkeletonDiv width={"65px"} height="14px" />
      </CredentialsStatus>
    </ListWrapperLeft>
  );
}

function AdquiredProductsSkeleton() {
  const randomValue = () =>
    `${Math.floor(Math.random() * (200 - 50 + 1)) + 50}px`;
  return (
    <Flex justify="space-between" full mb={"24px"}>
      <Flex direction="column" gap="4px" items="flex-start">
        <SkeletonDiv width={randomValue()} height="14px" />
        <SkeletonDiv width={randomValue()} height="14px" />
      </Flex>

      <Flex gap="16px">
        <SkeletonDiv width={"70px"} height="14px" />
        <ChevronDown2 />
      </Flex>
    </Flex>
  );
}
